import { withStatus } from 'hoc/Status/Status';
import Component from './InvoiceSendCcsEmail';
import { InvoiceSendCcsEmailProps } from './interfaces';

const InvoiceSendCcsEmail = withStatus<InvoiceSendCcsEmailProps>(Component);

export default InvoiceSendCcsEmail;
